const IG = require("./IGflower.png");
const IGhover = require("./IGhover.png");
const FB = require("./FBflower.png");
const FBhover = require("./FBhover.png");
const LI = require("./LIflower.png");
const LIhover = require("./LIhover.png");

export { IG, IGhover, FB, FBhover, LI, LIhover };